import { ApiGetDictWordVoice } from "@/service/apis/dictionary.js";
import { ApiGetVoiceSample } from "@/service/apis/challenge.js";
import { ApiDailySpeechGetVoiceSample } from "@/service/apis/dailyAispeech.js";
import { ApiGetConversationVoice } from "@/service/apis/dailyConversation.js";
import { Howl } from "howler";
import { useRecordingStore } from "@/store/modules/recording.js";
import { useGlobalStore } from "@/store/modules/global";
var sentenceSound = null;

export function stopSound() {
  if (sentenceSound != null) {
    sentenceSound.stop();
    sentenceSound.unload();
    sentenceSound = null;
  }
  const rs = useRecordingStore();
  rs.$patch((state) => {
    state.playDemoStatus = false;
  });
}

export function playWordVoice(word) {
  const global = useGlobalStore();
  if (!global.hideLoading) {
    // console.log("set loading");
    global.$patch((state) => {
      state.APIisLoading = true;
    });
  }

  if (sentenceSound != null) {
    sentenceSound.stop();
    sentenceSound.unload();
    sentenceSound = null;
  }
  console.log("play word voice");
  console.log(word);
  let keyword = word.trim();
  ApiGetDictWordVoice.get(keyword)
    .then((response) => {
      if (
        response.type !== "audio/mpeg" &&
        response.type !== "audio/wav" &&
        response.type !== "audio/x-wav"
      ) {
        response.text().then((textPayload) => {
          console.warn("Voice sample is not audio. Raw payload:", textPayload);
        });
        if (!global.hideLoading) {
          global.$patch((state) => {
            state.APIisLoading = false;
          });
        }
        return;
      }

      if (response.type == "image/jpeg" || response.type == "image/png") {
        var url = URL.createObjectURL(response);
      } else if (
        response.type == "audio/mpeg" ||
        response.type == "audio/wav" ||
        response.type == "audio/x-wav"
      ) {
        //會進到這裡\
        console.log("進入播放");
        const rs = useRecordingStore();
        rs.$patch((state) => {
          state.playDemoStatus = true;
        });

        var url = URL.createObjectURL(response);
        sentenceSound = new Howl({
          src: url,
          html5: true,
        });
        // let audio = new Audio(url);
        // console.log(audio);
        if (!global.hideLoading) {
          global.$patch((state) => {
            state.APIisLoading = false;
            state.changeIconColor = keyword;
          });
        }
        sentenceSound.play();
        sentenceSound.on("end", function () {
          rs.$patch((state) => {
            state.playDemoStatus = false;
          });
          global.$patch((state) => {
            state.changeIconColor = false;
          });
        });
      } else {
        console.log(response);
      }
    })
    .catch((err) => {
      console.log(err);
    });
}

export function playSampleSentence(tid, options = {}) {
  const global = useGlobalStore();
  const isDailySpeech =
    options && typeof options === "object" && options.isDailySpeech === true;
  if (!global.hideLoading) {
    // console.log("set loading");
    global.$patch((state) => {
      state.APIisLoading = true;
    });
  }
  if (sentenceSound != null) {
    console.log("關閉上個錄音");
    sentenceSound.stop();
    sentenceSound.unload();
    sentenceSound = null;
  }
  const apiPromise = isDailySpeech
    ? ApiDailySpeechGetVoiceSample.get(tid)
    : ApiGetVoiceSample.get(tid);
  apiPromise
    .then((response) => {
      console.log(response);
      if (response.type == "image/jpeg" || response.type == "image/png") {
        var url = URL.createObjectURL(response);
      } else if (
        response.type == "audio/mpeg" ||
        response.type == "audio/wav" ||
        response.type == "audio/x-wav"
      ) {
        //會進到這裡\
        console.log("進入播放");
        const rs = useRecordingStore();
        rs.$patch((state) => {
          state.playDemoStatus = true;
        });
        var url = URL.createObjectURL(response);
        sentenceSound = new Howl({
          src: url,
          html5: true,
        });
        // let audio = new Audio(url);
        // console.log(audio);
        if (!global.hideLoading) {
          global.$patch((state) => {
            state.APIisLoading = false;
            state.changeIconColor = tid;
          });
        }
        sentenceSound.play();
        sentenceSound.on("end", function () {
          rs.$patch((state) => {
            state.playDemoStatus = false;
          });
          global.$patch((state) => {
            state.changeIconColor = false;
          });
        });
      } else {
        console.log(response);
      }
    })
    .catch((err) => {
      console.log(err);
    });
}
